import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/sublocation'
import pathMap from 'src/paths/pathMap'

class SublocationRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SUB_LOCATION_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SUB_LOCATION_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SUB_LOCATION_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SUB_LOCATION_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default SublocationRoute
